import React, { ReactNode } from 'react';
import { SwitchWithText } from 'components/switch/SwitchWithText';
import { OrderingSettingsTableProps, styles } from './OrderingSettingsTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { colors } from 'styles/settings';

export type ToggleTableProps = {
    learnMoreLink: string;
    children: ReactNode;
} & Omit<OrderingSettingsTableProps, 'data' | 'learnMoreVariant' | 'variant'>;

export const ToggleTable = ({
    title,
    subTitle,
    isToggleOn,
    setIsToggleOn,
    isDisabled,
    learnMoreLink,
    children,
}: ToggleTableProps) => {
    return (
        <div className={styles.mainContainer}>
            <div className={`max-w-full p-6 ${isDisabled ? styles.disabled : ''}`}>
                <div className="max-w-full flex items-center justify-between">
                    <span className="text-brand-dark text-xl font-semibold">{title}</span>
                    <SwitchWithText
                        isDisabled={isDisabled}
                        checked={isToggleOn}
                        onChange={setIsToggleOn}
                    />
                </div>
                {subTitle ? (
                    <div className="max-w-full flex items-center justify-between">
                        <span className="text-grey text-sm font-light sm:w-10/12 w-full">
                            {subTitle}
                        </span>
                        <div />
                    </div>
                ) : null}
            </div>
            <div className={`max-w-full px-6 overflow-x-auto ${isDisabled ? styles.disabled : ''}`}>
                <table className="w-full table-auto text-sm font-normal ">
                    <tbody>
                        <tr className="bg-white">
                            <td>{children}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className={`w-full h-8 ${isDisabled ? styles.disabled : ''}`} />
            <div className="max-w-full flex items-end justify-end pt-0">
                <div className={`flex-1 h-10 ${isDisabled ? styles.disabled : ''}`} />
                <a className={styles.learnMoreLink} target="_blank" href={learnMoreLink}>
                    Learn More{' '}
                    <FontAwesomeIcon
                        icon={faExternalLink}
                        color={colors.brand}
                        className="ml-1.5"
                        size="1x"
                    />
                </a>
            </div>
        </div>
    );
};
